import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  LOAD_PREFERRED_SITE_LIST,
  LOAD_PREFERRED_SITE_LIST_SUCCESS,
  LOAD_PREFERRED_SITE_LIST_ERROR,
  RESET_PREFERRED_SITE_LIST,
} from '../type';
import { initialState } from './initialize';
import { uniqBy } from 'lodash';

const preferredSiteReducer = handleActions(
  new Map([
    [
      LOAD_PREFERRED_SITE_LIST,
      (state, action) => {
        return update(state, {
          loading: {
            $set: {
              ...state.loading,
              [action?.payload?.filter?.location]: true,
            },
          },
        });
      },
    ],
    [
      LOAD_PREFERRED_SITE_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loading: {
            $set: {
              ...state.loading,
              [action?.payload?.location]: false,
            },
          },
          [action.payload.location]: {
            $set: action.payload.response,
          },
          data: {
            $set: uniqBy([...state.data, ...action.payload.response], 'id'),
          },
        });
      },
    ],
    [
      LOAD_PREFERRED_SITE_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loading: {
            $set: {
              ...state.loading,
              [action?.payload?.location]: false,
            },
          },
          error: {
            $set: action.payload.error,
          },
        });
      },
    ],
    [
      RESET_PREFERRED_SITE_LIST,
      state => {
        return update(state, {
          loading: { $set: false },
          data: {
            $set: [],
          },
        });
      },
    ],
  ]),
  initialState,
);

export default preferredSiteReducer;
